// ##### 25-04-30 Komarov
import React, { useEffect, useState } from 'react';
// ##### 24-02-28 Komarov
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
// ##### 23-04-12 Komarov
import { Checkbox } from 'antd';
import uniqueId from 'lodash.uniqueid';
// ##### 25-05-21 Komarov
import PayRotaryRegistration from '../../Library/LiqPay/PayRotaryRegistration/PayRotaryRegistration';
import TermsConditions from '../BookingForm/TermsConditions';
// ##### 25-01-14 Komarov
import { getPostObject } from '../../../helpers/crypto';

// ##### Komarov 2025-07-14
const RegistrationRotary = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // ##### Komarov 2025-08-05
  const RotaryRegSummary = useLocalizedText('RotaryRegSummary');
  const AgreeTermsCond = useLocalizedText('AgreeTermsCond');

  const [termsTicked, setTermsTicked] = useState(false);
  const [readTerms, setReadTerms] = useState(false);
  // ##### 23-03-29 Komarov
  const [clicked /* setClicked */] = useState(false);

  // ##### 24-02-28 Komarov
  const { user: currentUser } = useSelector(state => state.auth);
  const user_id = currentUser.user_id;
  const [userData, setUserData] = useState([]);

  const AgreedFunc = () => {
    setTermsTicked(!termsTicked);
  };

  const ReadTermsFunc = () => {
    setReadTerms(!readTerms);
  };

  const closeTermsConditions = () => {
    setReadTerms(false);
  };
  // ##### 25-01-13 Komarov
  const locale = useSelector(state => state.language);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-03-21 Komarov
    const array = [];
    const postObject = getPostObject({
      action: 'GetRotaryUserRQ',
      user_id: user_id,
      refpartner: currentUser.company_id,
      language: locale,
    });

    axios
      .post(postObject.url, postObject.parameters)
      // ##### 24-11-01 Komarov
      .then(async response => {
        // console.log('ROTARY_REGISTRATION: RESPONSE', response)
        // setUserData(response.data.client_data[0]) //data[0].data.client_data
        // ##### 24-03-21 Komarov
        for (const key in await response.data[0].data.client_data[0]) {
          const obj = {
            form_key: key,
            form_value: await response.data[0].data.client_data[0][key],
          };
          array.push(obj);
        }
        // setUserData(response.data[0].data.client_data[0])
        setUserData(array);
      })
      .catch(error => {
        // ##### 25-04-30 Komarov
        console.error('[axios error]: ', error);
      });
    // ##### 23-04-12 Komarov
  }, [user_id]);
  // console.log('ROTARY_REGISTRATION: userData:',userData)

  return (
    <div
      style={{ marginTop: '3vh', marginBottom: '4vh' }}
      data-component="RegistrationRotary"
    >
      <h2
        style={{
          color: 'darkblue',
          fontStyle: 'Arial Narrow',
          fontSize: '35px',
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: '4vh',
        }}
      >
        {
          // ##### 23-10-04 Komarov
          RotaryRegSummary
        }
      </h2>

      {userData.map(item => {
        return (
          // ##### 23-10-04 Komarov
          <div key={uniqueId()} className="RegistrationForm">
            <div className="Form_Key">{item.form_key.toUpperCase()}</div>
            <div className="Form_Value">{item.form_value}</div>
          </div>
        );
      })}

      <div className="WrapperTermsConditions Rotary">
        <Checkbox
          onChange={AgreedFunc}
          defaultChecked={false}
          disabled={clicked !== false}
          style={{
            textAlign: 'center',
            marginRight: '2vw',
            marginTop: 'auto',
            marginBottom: 'auto',
            border: '2px solid blue',
            borderRadius: '60px',
            background: 'lightblue',
            padding: '10px',
          }}
        />
        <div
          className="TermsConditions Registration"
          onClick={ReadTermsFunc}
          //   ##### 24-03-21 Komarov
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              ReadTermsFunc();
            }
          }}
        >
          {
            // ##### 23-10-04 Komarov
            AgreeTermsCond
          }
        </div>
      </div>
      {readTerms === true ? (
        <div style={{ marginLeft: '6vw' }}>
          <TermsConditions
            readTerms={readTerms}
            closeTermsConditions={closeTermsConditions}
          />
        </div>
      ) : null}
      {termsTicked === true ? (
        <PayRotaryRegistration userData={userData} />
      ) : null}
    </div>
  );
};

export default RegistrationRotary;
